import { React, useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Admin from "app/scenes/Home.js";
import "app/layout/material-dashboard-react.css?v=1.10.0";
import { LocalizationProvider } from '@mui/x-date-pickers';
import DateAdapter from '@mui/lab/AdapterDateFns';
import enLocale from 'date-fns/locale/en-GB';
import { LoginStatusContext } from "app/context/LoginStatusContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import axios from "axios";

const App = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loginRefreshRequired, setLoginRefreshRequired] = useState(false);

    axios.defaults.withCredentials = true;
    
    return (
        <GoogleReCaptchaProvider reCaptchaKey='6LdAmtsfAAAAAMBHbsdHBB6HRuy6LCEOQEfgBfUu'>
            <LoginStatusContext.Provider value={{isLoggedIn, setIsLoggedIn, loginRefreshRequired, setLoginRefreshRequired}}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={enLocale}>
                <Switch>
                    <Route path="/LeoSeaPortal" component={Admin} />
                </Switch>
            </LocalizationProvider>
        </LoginStatusContext.Provider>
        </GoogleReCaptchaProvider>
    );
};

ReactDOM.render(
    <BrowserRouter>
       <App> </App>
    </BrowserRouter>,
    document.getElementById("root")
);

